import { addFavoriteSlotType, removeFavoriteSlotType, isSlotTypeFavorite } from './SlotLocalStorageManager';
export function slotName(slot, outcome, gridLocalization, matchMap) {
    var sportId = matchMap.get('realSportId');
    var match = {
        homeTeam: matchMap.get('firstTeam'),
        awayTeam: matchMap.get('secondTeam')
    };
    var outcomeName = gridLocalization.getOutcomeName(sportId, outcome.toJS(), match);
    return outcomeName;
}
export function byIdComparator(a, b) {
    return a.get("id") - b.get("id");
}
export function onLongTouch(slot, match) {
    var slotType = slot.type;
    var realSportId = match.get('realSportId');
    if (isSlotTypeFavorite(slotType, realSportId)) {
        removeFavoriteSlotType(slotType, realSportId);
    }
    else {
        addFavoriteSlotType(slotType, realSportId);
    }
}



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/slotUtils.js